import { useCallback, useMemo } from 'react';

/**
 * useSequentialInteractive
 * - Memindahkan logic sequential (sentence_arrangement) dari QuestionsForm supaya tidak menumpuk.
 * - IMPORTANT: tidak mengubah logic existing.
 */
export function useSequentialInteractive(params) {
  const {
    type,
    interactiveType,
    isInteractiveEnabled,
    answer,
    choice,
    dispatch,
    setField,
    stateChoiceFromRedux,
    setStateChoiceFromRedux,
  } = params;

  // ✅ Helper flag: sequential interactive (khusus sentence_arrangement)
  const isSequentialInteractive = useMemo(() => {
    return type === 'sentence_arrangement' && isInteractiveEnabled && interactiveType === 'sequential';
  }, [type, isInteractiveEnabled, interactiveType]);

  // ✅ Shuffle helper khusus sequential: shuffle array, best-effort supaya beda dari original
  const shuffleArrayEnsureDifferent = useCallback((arr, maxAttempts = 5) => {
    const base = Array.isArray(arr) ? [...arr] : [];
    if (base.length <= 1) return base;

    const isSame = (a, b) => a.length === b.length && a.every((v, i) => v === b[i]);

    for (let attempt = 0; attempt < maxAttempts; attempt += 1) {
      const next = [...base];
      // Fisher–Yates shuffle
      for (let i = next.length - 1; i > 0; i -= 1) {
        const j = Math.floor(Math.random() * (i + 1));
        const tmp = next[i];
        next[i] = next[j];
        next[j] = tmp;
      }
      if (!isSame(next, base)) return next;
    }

    // Kalau kebetulan selalu sama (rare), return base
    return base;
  }, []);

  // ✅ Sequential: input hanya update answer (choice akan dibuat dari shuffle answer saat save)
  const handleChangeSequentialAnswerOnly = useCallback((index, value) => {
    const updatedAnswer = Array.isArray(answer) ? [...answer] : [];
    updatedAnswer[index] = value;
    dispatch(setField({ field: 'answer', value: updatedAnswer }));
  }, [answer, dispatch, setField]);

  // ✅ Save/trigger: khusus sequential => choice = shuffle(answer)
  const triggerSetReduxData = useCallback(() => {
    if (isSequentialInteractive) {
      const currentAnswer = Array.isArray(answer) ? answer : [];
      const shuffledChoice = shuffleArrayEnsureDifferent(currentAnswer);

      // answer = kunci (tidak diubah), choice = opsi yang diacak
      dispatch(setField({ field: 'choice', value: shuffledChoice }));

      // Optional: sync local state biar kalau UI butuh, choice-nya ikut kebaca
      setStateChoiceFromRedux(shuffledChoice);
      return;
    }

    // Default behavior untuk mode lain: simpan choice dari local state
    dispatch(setField({ field: 'choice', value: stateChoiceFromRedux }));
    console.log('data.choice', choice);
    console.log('stateChoiceFromRedux', stateChoiceFromRedux);
  }, [
    isSequentialInteractive,
    answer,
    dispatch,
    setField,
    setStateChoiceFromRedux,
    stateChoiceFromRedux,
    shuffleArrayEnsureDifferent,
    choice,
  ]);

  return {
    isSequentialInteractive,
    handleChangeSequentialAnswerOnly,
    triggerSetReduxData,
  };
}
